<template>
  <component :is="layoutComponent" :field="field" :errors="errors">
    <template slot="field">
      <div class="input-group">
        <input
          :id="field.attribute"
          v-model="fieldValue"
          :placeholder="inputPlaceholder"
          :max="inputMax"
          :disabled="loading"
          :class="errorClasses"
          type="text"
          class="form-control"
        />
        <div class="input-group-append">
          <button
            v-if="valid"
            disabled
            class="btn btn-outline-success"
            type="button"
          >
            {{ $t("Valid") }}
          </button>
          <button
            v-else
            :disabled="loading"
            class="btn btn-outline-secondary"
            type="button"
            @click="check"
          >
            {{ loading ? $t("Validating...") : $t("Validate") }}
          </button>
        </div>
      </div>
    </template>
  </component>
</template>

<script>
import { FormTextField } from "stylemix-base";

export default {
  name: "FormVatField",

  extends: FormTextField,

  data: () => ({
    valid: false,
    loading: false,
    token: null,
  }),

  created() {
    this.field.fillFormData = (formData) => {
      formData.append(this.field.attribute, this.fieldValue);
      formData.append("vat_token", this.token || "");
    };

    if (this.model && this.model.vat_token) {
      this.token = this.model.vat_token;
      this.valid = true;
    }

    setTimeout(() => {
      this.$events.$on("field-change-" + this.field.attribute, () => {
        this.valid = false;
        this.token = null;
      });
    }, 1000);
  },

  methods: {
    check() {
      if (!this.fieldValue) {
        return;
      }

      this.loading = true;

      this.$http
        .post("vat/token", { vat_number: this.fieldValue })
        .then((response) => {
          this.errors.clear();

          if (!response.data.token) {
            this.errors.all()[this.field.attribute] = [
              this.$t("VAT number is invalid"),
            ];
            return;
          }

          this.valid = true;
          this.token = response.data.token;
          this.$events.$emit("vat-validated", response.data);
          if (this.model) {
            this.model.vat_token = this.token;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
